import { clearBillingCheckoutContext } from './billingCheckoutContext';

export type BillingReturn = {
  result: 'success' | 'cancel' | null;
  sessionId: string | null;
};

export function readBillingReturn(rawUrl = window.location.href): BillingReturn {
  const url = new URL(rawUrl);
  const result = url.searchParams.get('billing');
  return {
    result: result === 'success' || result === 'cancel' ? result : null,
    sessionId: url.searchParams.get('billing_session_id'),
  };
}

export function hasBillingReturn(rawUrl = window.location.href): boolean {
  return readBillingReturn(rawUrl).result !== null;
}

export function clearBillingReturn(rawUrl = window.location.href): void {
  const url = new URL(rawUrl);
  url.searchParams.delete('billing');
  url.searchParams.delete('billing_session_id');
  clearBillingCheckoutContext(url);
  window.history.replaceState(window.history.state, '', url);
}
